
import SideNav from "./SideNav";
import TopBar from "./TopBar";
import React, { useState,  useEffect, useRef } from 'react';
import axios from 'axios';
import { BrowserRouter as Router,Switch,Route,Link,useParams,params} from "react-router-dom";
import Swal from 'sweetalert2';
import placeholderImage from '../img/image_placeholder.png';
import { Modal, Carousel, Button } from 'react-bootstrap';


function InventoryDetails(){

    const API_URL = process.env.REACT_APP_API_URL;
    const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;
    const { id } = useParams();
    const [selectedImageIndex, setSelectedImageIndex] = useState(null);

    const [inventory, setInventory] = useState([]);
    const [coverImages, setCoverImages] = useState([]);
    const [mergedArray, setMergedArray] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isImageLoading, setIsImageLoading] = useState(true);
    const [isModalImageLoading, setIsModalImageLoading] = useState(true);
const [showFullDescription, setShowFullDescription] = useState(false);
const [showMore, setShowMore] = useState(false);
  const descriptionRef = useRef(null);
  const [key_description, setkey_description] = useState([]);
const [clientHeight, setClientHeight] = useState();
const [scrollHeight, setScrollHeight] = useState();



const toggleDescription = () => {
  setShowFullDescription(!showFullDescription);
};

const toggleFeatures = () => {
    setShowMore(!showMore);
  };

  

    useEffect(() => {   
       
         setIsLoading(true);
         getInventoryById(id);   
        
          }, []);
        

    function getInventoryById(id){
 
        axios.get(`${API_URL}/inventory-details/`+id).then(res=>{
            if(res.data.status === 200){
                setInventory(res.data.inventorySection[0]);
            //  setkey_description(res.data.inventorySection[0].key_description);
                setMergedArray(res.data.inventorySection.map(section => {
                    const inventorySection2 = res.data.inventorySection2.find(data => data.inventory_section_id === section.id);
                    const coverImage = res.data.inventoryCoverImages.find(image => image.inventory_section_id === section.id);
                    const inventoryImages = res.data.inventoryImages.find(image => image.inventory_section_id === section.id);
                    const price = res.data.inventorySection3.find(data => data.inventory_section_id === section.id);
                    
                    return { ...section, inventorySection2, coverImage,inventoryImages, price };    
                   
                  }))  

                  const descriptionElement = descriptionRef.current;
                  if (descriptionElement) {
                    // const isTruncated = descriptionElement.scrollHeight > descriptionElement.clientHeight;
                    // setShowFullDescription(!isTruncated);
                    setClientHeight(descriptionElement.clientHeight);
                    setScrollHeight(descriptionElement.scrollHeight);
                  } 
                         
            }
            else if(res.data.status === 404){
                //setMessage(res.data.message);
                console.log(res.data.status);
                //setIsLoading(false);
                }
            setIsLoading(false);
         });
        
        }



        const handleImageLoad = () => {
        
            setIsImageLoading(false);
           // setIsLoading(false);
        };

        
        const handleModalImageLoad = () => {
        
          setIsModalImageLoading(false);
      };

        // function preloadImage(url) {
        //     const img = new Image();
        //     img.src = url;
        //     console.log(img.src)
        // };
     
return(
    <div>
    <SideNav/>
    <TopBar/>
    {isLoading?
     <div className="loader-container" style ={{backgroundColor: "rgba(0, 0, 0, 0.5)", position: "fixed",top: "0",left: "0",width: "100%",height: "100%",display: "flex",justifyContent: "center",alignItems: "center",zIndex: "9999"}}>
    <div class="d-flex justify-content-center">
  <div class="spinner-border" role="status">
  </div>
  </div>
</div>:null}

                        
                        {mergedArray.map(function fn(item){  
               return(
               
<div class="right_panel position contact_section vh-100" id="right_panel">
  
                   <>
               
                  <div  style={{padding:"10px 100px 0px 100px"}}>                 
                   <div class="content_wrapper pt-4" >   
                   <Link to={`/view-inventory`} >
                   <p style={{marginBottom:"20px"}} ><i  class="bi bi-arrow-left"> Back to search results</i> </p> </Link>             
                   <div class="vm_content_box_1">
    , 
                        
   <div class="title" style={{position: "fixed",
  top: "0",
  width: "70%",
  zIndex: "100"}}>

<div class="col-md-6">
  
  <h2 style={{fontSize:"16px"}} ><i class="bi bi-car-front-fill"></i>  {item.vehicle_name}  {item.trim}  {item.drive_type} </h2>
  <div class="row" style={{marginTop:"-15px"}}>
 <p class="text-muted pt-1" style={{fontSize:"12px",marginLeft:"25px"}}>{item.condition} | {item.odometer.toLocaleString()} KM</p> 
</div>
  </div>
  <div class="col-md-6" style={{alignItems:"right",marginRight:"-90px"}}>
  <div class="d-md-flex justify-content-between">
                                          <div class="lh-1"><i class="bi bi-tags fs-6"></i> <span class="vm_font_semi_bold vm_text_color_secondary fs-6"><span class="currency">$</span>{item.price && item.price.sale_price.toLocaleString()}</span> + Tax </div>
                                         
                                      </div>

</div>




  
   </div>
  
   <div class="content pt-3">
  
    <div class="content pt-2 pb-2">
        <div class="row">
            <div class="col-md-6">


{/* {item.coverImage ? (
   <img
   style={isImageLoading ? { width: "111%", height: "90%" } : {
       width: "560px",
       height: "385px",
       backgroundColor: "lightgray",
       backgroundImage: `url(${placeholderImage})`,
       backgroundSize: "cover",
       backgroundPosition: "center",
   }}
   src={`${LARAVEL_API_URL}${item.coverImage.filepath}`}
   onLoad={handleImageLoad}
   onClick={() => setSelectedImageIndex(0)} // Open popup with cover image selected
/>
) : (
  <div style={{ 
    position: 'relative', 
    width: '570px', 
    height: '385px', 
    backgroundColor: 'lightgray', 
    backgroundImage: `url(${placeholderImage})`, 
    backgroundSize: 'cover', 
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

  }}>
    <span style={{
      position: 'absolute',
      color: 'grey',
      padding: '10px 20px',
      borderRadius: '5px',
      fontSize: '20px',
      backgroundColor: "rgba(255, 255, 255, 0.7)"
    }}>{'No image available'}</span>
  </div>

)} */}
<div style={{ position: 'relative', width: '560px', height: '385px' }}>

{(isImageLoading && item.coverImage) ? 
<img onLoad={handleImageLoad} src={placeholderImage}/> : 
<img style={{ width: "560px", height: "385px"}} onClick={() => setSelectedImageIndex(0)} src={item.coverImage ? `${LARAVEL_API_URL}${item.coverImage.filepath}` : placeholderImage}  />

}
{!item.coverImage && (
    <span 
    style={{
      position:'absolute',
      top: "50%", 
      left: "50%", 
      transform: "translate(-50%, -50%)", 
      color: "black",
      fontSize: '25px',
      backgroundColor: "rgba(255, 255, 255, 0.7)", // Optional: Adds a background to the text for better readability
      padding: "2px 5px", // Optional: Adds padding around the text
      borderRadius: "3px" // Optional: Rounds the corners of the text background
    }} >No image available
    </span>
)} 

</div>
            </div>
            <div class="col-md-6">
                <div class="col" style={{marginLeft:"40px",marginTop:"-3px"}} >
                    {item && item.inventoryImages && item.inventoryImages.filepath_compressed &&
                    item.inventoryImages.filepath_compressed.split(',').slice(0, 3).map((option, index) => (
                       
                       
                      <div class="col-md-4" key={option}>
                      <div  class="border-bottom pb-1 pt-1"  style={{ position: 'relative', width: '100%', height: '100%'  }} onClick={() => setSelectedImageIndex(index + 1)}>

                      {isImageLoading ? 
                      <img onLoad={handleImageLoad} src={placeholderImage}/> : 
                      <img style={{ width: "150px", height: "115px"}}  src={item.inventoryImages ? `${LARAVEL_API_URL}${option}` : placeholderImage}  />
                      }
                     {index === 2 && (item.inventoryImages.filepath_compressed.split(',').length - 3) > 0 && (
                                    <div
                                        class="overlay"
                                        style={{
                                            position: 'absolute',
                                            top: "0px",
                                            left: "0px",
                                            width: '100%',
                                            height: '100%',
                                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <span className="overlay-text" style={{ color: 'white', fontWeight: 'bold', fontSize: '24px' }}>
  {(item.inventoryImages.filepath_compressed.split(',').length - 3) > 0 
    ? `+${item.inventoryImages.filepath_compressed.split(',').length - 3}` 
    : null}
</span>
                                    </div>
                                )}
                      
                      </div>
                       
                {/* <div
                                 class="border-bottom pb-1 pt-1"
                                style={{ position: "relative" }}
                                onClick={() => setSelectedImageIndex(index + 1)} // Open popup with selected image
                            >
                                <img
                                style={isImageLoading ? { width: "100%", height: "100%" } : {
                                    width: "150px",
                                    height: "115px",
                                    backgroundColor: "lightgray",
                                    backgroundImage: `url(${placeholderImage})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                }}
                                
                                    // style={{ width: "100%", height: "100%" }}
                                    src={`${LARAVEL_API_URL}${option}`}
                                />
                                {index === 2 && (item.inventoryImages.filepath_compressed.split(',').length - 3) > 0 && (
                                    <div
                                        class="overlay"
                                        style={{
                                            position: 'absolute',
                                            top: "0px",
                                            left: "0px",
                                            width: '100%',
                                            height: '100%',
                                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <span className="overlay-text" style={{ color: 'white', fontWeight: 'bold', fontSize: '24px' }}>
  {(item.inventoryImages.filepath_compressed.split(',').length - 3) > 0 
    ? `+${item.inventoryImages.filepath_compressed.split(',').length - 3}` 
    : null}
</span>
                                    </div>
                                )}
                            </div> */}
                        </div>
                    ))}

{/* {item.inventoryImages && item.inventoryImages.filepath_compressed && item.inventoryImages.filepath_compressed.split(',').slice(0, 3).forEach((option) => preloadImage(`${LARAVEL_API_URL}${option}`))} */}

                </div>
            </div>
        </div>
    </div>
    <Modal
  show={selectedImageIndex !== null}
  onHide={() => setSelectedImageIndex(null)}
  centered
  size="lg" 
>
    
<Modal.Header closeButton></Modal.Header>
  <Modal.Body>
    <Carousel
      interval={null}
      activeIndex={selectedImageIndex}
      onSelect={(index) => setSelectedImageIndex(index)}
     prevIcon={<span class="carousel-control-prev-icon"  style={{backgroundColor:"white", borderRadius:"10%", color:"black"}}>
        <svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>  
     </span> } 
     nextIcon={<span class="carousel-control-next-icon"  style={{backgroundColor:"white", borderRadius:"10%", color:"black"}}>
    <svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg> 
     </span> } 
      
    >
       
      <Carousel.Item>

      {/* {(isModalImageLoading) ? 
                      <img onLoad={handleModalImageLoad} src={placeholderImage}/> : 
                      <img style={{ objectFit: "contain", maxHeight: "100%", maxWidth: "100%" }}  src={item.coverImage ? `${LARAVEL_API_URL}${item.coverImage.filepath}` : placeholderImage}  />
                      } */}



      {item && item.coverImage && (
  <img
    src={`${LARAVEL_API_URL}${item.coverImage.filepath}`}
    alt="Cover"
    style={{ objectFit: "contain", maxHeight: "100%", maxWidth: "100%" }}
  />
)}
      </Carousel.Item>
      
      {item && item.inventoryImages && item.inventoryImages.filepath_compressed.split(",").map((option, index) => (
  <Carousel.Item key={option}>

{/* {(isModalImageLoading) ? 
                      <img onLoad={handleModalImageLoad} src={placeholderImage}/> : 
                      <img  style={{ objectFit: "contain", maxHeight: "100%", maxWidth: "100%" }}  src={item.inventoryImages ? `${LARAVEL_API_URL}${option}` : placeholderImage}  />
                      } */}

    <img
      src={`${LARAVEL_API_URL}${option}`}
      alt={`Image ${index}`}
      style={{ objectFit: "contain", maxHeight: "100%", maxWidth: "100%" }}
    />

  </Carousel.Item>
))}
      
    </Carousel>
  </Modal.Body>
</Modal>
</div>
</div>

                           </div>
                           </div>   

                           <div  style={{padding:"0px 100px 0px 100px"}}>
                   <div class="content_wrapper pt-0">
                           <div class="vm_content_box_1">
                               <div class="title">
                                   <h2>Highlights</h2>
                               </div>
    
                               <div class="content pt-3">

<div class="content pt-1 pb-4">
<div class="row">
    <div class="col">
        <div class="row">
            <div class="col">
                <h3 style={{fontSize:"30px", padding:"10px"}}>
                    <svg class="b1rIwt" viewBox="0 0 24 24" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="34" height="34" fill="none" data-icon="true"><path fill="currentColor" d="M5.632 6.632c3.509-3.51 9.219-3.51 12.728 0 3.509 3.509 3.509 9.219 0 12.728a0.748 0.748 0 01-1.06 0 0.75 0.75 0 010-1.06c2.923-2.925 2.923-7.683 0-10.608-2.925-2.924-7.683-2.924-10.608 0-2.924 2.925-2.924 7.683 0 10.607a0.75 0.75 0 11-1.06 1.06c-3.51-3.508-3.51-9.218 0-12.727z"></path><path fill="currentColor" d="M11.466 8.776a0.73 0.73 0 01-0.22-0.53 0.738 0.738 0 010.127-0.418 0.79 0.79 0 010.335-0.275 0.753 0.753 0 011.037 0.693 0.738 0.738 0 01-0.127 0.417 0.754 0.754 0 01-1.04 0.205 0.79 0.79 0 01-0.112-0.092zM8.923 15.66a0.834 0.834 0 010.245 0.163 0.758 0.758 0 010.163 0.818 0.821 0.821 0 01-0.163 0.245 0.767 0.767 0 01-0.53 0.217 0.769 0.769 0 01-0.532-0.218 0.82 0.82 0 01-0.162-0.245 0.718 0.718 0 01-0.058-0.288 0.759 0.759 0 010.335-0.622 0.846 0.846 0 010.13-0.07 0.88 0.88 0 010.14-0.042 0.808 0.808 0 010.292 0 0.865 0.865 0 010.14 0.043zm8.353-2.134a0.802 0.802 0 000.162-0.243 0.739 0.739 0 00-0.162-0.817 0.751 0.751 0 00-1.28 0.53 0.753 0.753 0 000.897 0.734 0.687 0.687 0 000.268-0.112 0.703 0.703 0 000.115-0.092zm-10.56-1.06a0.774 0.774 0 011.06 0 0.754 0.754 0 010.22 0.53 0.754 0.754 0 01-0.75 0.75 0.753 0.753 0 01-0.75-0.75c0-0.198 0.08-0.39 0.22-0.53zm8.492 3.152a0.728 0.728 0 00-0.27 0.112 0.752 0.752 0 00-0.333 0.623 0.768 0.768 0 000.218 0.532 0.758 0.758 0 001.06 0 0.759 0.759 0 000.22-0.532c0-0.198-0.08-0.39-0.217-0.53a0.767 0.767 0 00-0.678-0.205zM9.26 9.22a0.811 0.811 0 010.07 0.13 0.714 0.714 0 010.057 0.285 0.77 0.77 0 01-0.219 0.533 0.767 0.767 0 01-0.53 0.218 0.76 0.76 0 01-0.532-0.218A0.77 0.77 0 017.9 9.491a0.904 0.904 0 010.042-0.14 0.83 0.83 0 010.163-0.245 0.782 0.782 0 011.062 0A1.063 1.063 0 019.261 9.22zm7.016 0.556a0.75 0.75 0 10-1.06-1.06l-0.383 0.382a0.04 0.04 0 01-0.005 0.004l-0.005 0.004-0.004 0.005a0.045 0.045 0 01-0.005 0.005l-2.024 2.025a2.002 2.002 0 00-2.794 1.835c0 1.103 0.897 2 2 2a2.002 2.002 0 001.846-2.767l2.434-2.433z"></path></svg>
                </h3>
                {item.odometer.toLocaleString()} km
            </div>
            <div class="col">
                <h3 style={{fontSize:"30px", padding:"10px"}}>
                <svg class="b1rIwt" viewBox="0 0 24 24" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="34" height="34" fill="none" data-icon="true"><path fill="currentColor" fill-rule="evenodd" d="M21 5a2 2 0 10-2.75 1.853v4.397h-5.5V6.853a2 2 0 10-1.5 0v4.397h-5.5V6.853a2 2 0 10-1.5 0v10.294a2 2 0 101.5 0V12.75h5.5v4.397a2 2 0 101.5 0V12.75h7V6.853A2 2 0 0021 5z" clip-rule="evenodd"></path></svg>
                </h3>
                {item.transmission} 
            </div>
            <div class="col">
                <h3 style={{fontSize:"30px", padding:"10px"}}>
                <svg class="b1rIwt" viewBox="0 0 24 24" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="34" height="34" fill="none" data-icon="true"><path fill="currentColor" fill-rule="evenodd" d="M16.5 15v2.5h-2.849l-1-1.5H7.5v-4.44l1.06-1.06h6.88l1.06 1.06V13h3v2h-3zm3.75-6a0.75 0.75 0 00-0.75 0.75v1.75H18v-0.56L16.06 9h-3.31V7.5h2.5a0.75 0.75 0 100-1.5h-6.5a0.75 0.75 0 100 1.5h2.5V9H7.94L6 10.94v2.43a0.748 0.748 0 00-0.188-0.026H4.5v-2a0.75 0.75 0 10-1.5 0v5.5a0.75 0.75 0 101.5 0v-2h1.313A0.748 0.748 0 006 14.817V17.5h5.849l1 1.5H18v-2.5h1.5v1.75a0.75 0.75 0 101.5 0v-8.5A0.75 0.75 0 0020.25 9z" clip-rule="evenodd"></path></svg>
                </h3>
                {item.drive_type} 
                
            </div>
        </div>
    </div>

    <div class="col">
        <div class="border-bottom pb-3 pt-2">
            <i style={{color:"#059618", fontSize:"15px"}} class="bi bi-check-circle-fill"></i> {item.condition} Vehicle
        </div>
        <div class="border-bottom pb-3 pt-2">
            <i style={{color:"#059618", fontSize:"15px"}} class="bi bi-check-circle-fill"></i> {item.stock_status}
        </div>
    </div>
</div>
    
</div>
</div>
                           </div>                    
                           </div>
                           </div>

                                 <div  style={{padding:"0px 100px 0px 100px"}}>
                   <div class="content_wrapper pt-0">
                           <div class="vm_content_box_1">
                               <div class="title">
                                   <h2>Description</h2>
                               </div>
                               <div class="content pt-3">

                                   <div class="content pt-1 pb-3" style={{fontSize:"14px"}}>
                                   <div class="row">

 
                                   {showFullDescription ? (
        <div >
          <div className="description" style={{ whiteSpace: "pre-line" }}>
            {item.key_description}
          </div>
        </div>
      ): 
      <div class="description" ref={descriptionRef} style={{display: '-webkit-box',WebkitLineClamp: '6',WebkitBoxOrient: 'vertical', overflow: "hidden", whiteSpace: "pre-line",textOverflow: 'ellipsis'}}>
      {item.key_description}
    </div>
      }
{scrollHeight > clientHeight && 
<button style={{border:"none",color:"green"}} onClick={toggleDescription}>
          {showFullDescription ? "Read Less" : "Read More"}
        </button>
      
                        }

  

                                       </div>
                                   </div>
                               </div>
                           </div>                    
                           </div>
                           <div class="content_wrapper pt-0">
                           <div class="vm_content_box_1">
                               <div class="title">
                                   <h2>Specifications</h2>
                               </div>
                               <div class="content pt-1">

                                   <div class="content pt-1 pb-3">
                                       <div class="row">
                                        
<div class="col-6">


        <div class="border-bottom pb-3 pt-2">
           <div class="row">
     <div class="col">Kilometers</div> 
     <div class="col" style={{fontWeight:"bold"}}> {item.odometer.toLocaleString()} km</div>
     </div>
     </div>
     <div class="border-bottom pb-3 pt-2">
           <div class="row">
     <div class="col">Status</div> 
     <div class="col" style={{fontWeight:"bold"}}> {item.condition}</div>
     </div>
     </div>
     <div class="border-bottom pb-3 pt-2">
           <div class="row">
     <div class="col">Trim</div> 
     <div class="col"style={{fontWeight:"bold"}}> {item.trim}</div>
     </div>
     </div>

     <div class="border-bottom pb-3 pt-2">
           <div class="row">
     <div class="col">Body Type</div> 
     <div class="col"style={{fontWeight:"bold"}}> {item.body_type}</div>
     </div>
     </div>
     <div class="border-bottom pb-3 pt-2">
           <div class="row">
     <div class="col">Engine</div> 
     <div class="col"style={{fontWeight:"bold"}}> {item.engine_type}</div>
     </div>
     </div>
     <div class="border-bottom pb-3 pt-2">
           <div class="row">
     <div class="col">Cylinder</div> 
     <div class="col" style={{fontWeight:"bold"}}> {item.cylinders}</div>
     </div>
     </div>
     </div>
     <div class="col-6 ">
     <div class="border-bottom pb-3 pt-2">
           <div class="row">
     <div class="col">Transmission</div> 
     <div class="col" style={{fontWeight:"bold"}}> {item.transmission}</div>
     </div>
     </div>
     <div class="border-bottom pb-3 pt-2">
           <div class="row">
     <div class="col">Drive Type</div> 
     <div class="col" style={{fontWeight:"bold"}}> {item.drive_type}</div>
     </div>
     </div>
     <div class="border-bottom pb-3 pt-2">
           <div class="row">
     <div class="col">Door</div> 
     <div class="col" style={{fontWeight:"bold"}}> {item.door}</div>
     </div>
     </div>
     <div class="border-bottom pb-3 pt-2">
           <div class="row">
     <div class="col">Fuel Type</div> 
     <div class="col" style={{fontWeight:"bold"}}> {item.fuel_type}</div>
     </div>
     </div>
     <div class="border-bottom pb-3 pt-2">
           <div class="row">
     <div class="col">Exterior Colour</div> 
     <div class="col" style={{fontWeight:"bold"}}> {item.exterior_color}</div>
     </div>
     </div>
     <div class="border-bottom pb-3 pt-2">
           <div class="row">
     <div class="col">Interior Colour</div> 
     <div class="col" style={{fontWeight:"bold"}}> {item.interior_color}</div>
     </div>
     </div>

        
</div>

                                       </div>
                                   </div>
                               </div>
                           </div>                    
                           </div>

                           <div class="content_wrapper pt-0">
                           <div class="vm_content_box_1">
                               <div class="title">
                                   <h2>Features & Options</h2>
                               </div>
                               <div class="content pt-3">

                                   <div class="content pt-0 pb-4">
                                   <div class="row">
  {item.inventorySection2 && item.inventorySection2.package_options && item.inventorySection2.technology_options ? (
    item.inventorySection2.package_options
      .split(',')
      .concat(item.inventorySection2.technology_options.split(','))
      .slice(0, showMore ? undefined : 8)
      .map((option) => (
        <div class="col-md-3" key={option}>
          <div class="border-bottom pb-3 pt-2">
            <i style={{ color: "#059618", fontSize: "15px" }} className="bi bi-check-circle-fill"></i> {option}
          </div>
        </div>
      ))
  ) : <p style={{ textAlign: "center" }}>No features & options available</p> }
</div>

    {item.inventorySection2 && item.inventorySection2.package_options && item.inventorySection2.technology_options && 
    (item.inventorySection2.package_options.split(',') 
    .concat(item.inventorySection2.technology_options.split(',')) .length > 8 && 
    ( <div class="row mt-3"> <div class="col-md-12"> <button style={{border:"none",color:"green"}} onClick={toggleFeatures} > 
    {showMore ? "Read Less" : "Read More"} </button> </div> </div> ) ) } 

                                       </div>
                                   </div>
                               </div>
                           </div>                    
                           </div>

                </>
                     </div>
                            );
                        })}
                       


</div>

   

   
)
}

export default InventoryDetails;